<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加角色"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="roleInfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="roleInfo.name" placeholder="请输入角色名">
        </Input>
      </FormItem>
      <FormItem prop="nickName">
        <Input v-model="roleInfo.nickName" placeholder="请输入昵称">
        </Input>
      </FormItem>
      <FormItem prop="description">
        <Input v-model="roleInfo.description" placeholder="请输入描述">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'AddRoleModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '角色名不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        roleSex:[
          {label:'女',value:0},
          {label:'男',value:1},
          {label:'未知',value:2},
        ],
        roleInfo: {
          name:null,
          nickName:null,
          description:null
        }
      }
    },
    methods: {
      ...mapActions([
        'RoleServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加角色',
          content: '<p>是否确认添加角色</p>',
          onOk: () => {
            store.dispatch('RoleServ_AddObj', {params: this.roleInfo}).then(() => {
              this.$Message.success('添加角色成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.roleInfo.name = null
          this.roleInfo.nickName = null
          this.description = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
